document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bfcm2026-wild').forEach(function (root) {
    // 链接带 ?part=wild-side 时滚到本模块，并避开顶部导航。
    var part = new URLSearchParams(window.location.search).get('part');
    if (!part || part !== root.getAttribute('data-jump-id')) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    var top = root.getBoundingClientRect().top + window.pageYOffset - header - 16;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
  });
});
